// Import modules / classes for npm
import "../css/index.scss"
import OnlineEncrypt from "./modules/OnlineEncrypt"

//Instantiate modules / classes for test page
const onlineMailEncrypt = new OnlineEncrypt(
      {
        type: "email",
        encButton: $(".email .enc-button"),
        decButton: $(".email .dec-button"),
        encryptedField: $(".email .encrypted-email input"),
        decryptedField: $(".email .decrypted-email input")
      });

const onlinePhoneEncrypt = new OnlineEncrypt(
      {
        type: "phone",
        encButton: $(".phone .enc-button"),
        decButton: $(".phone .dec-button"),
        encryptedField: $(".phone .encrypted-email input"),
        decryptedField: $(".phone .decrypted-email input")
      });